const normalizeSearchValue = (value) => String(value || '')
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '');

const digitsOnly = (value) => String(value || '').replace(/\D/g, '');

export const toCustomerDropdownItem = (item) => {
  if (!item) {
    return null;
  }

  const customerId = item.customerId || item.id;
  if (!customerId) {
    return null;
  }

  const name = item.name || item.displayName || '';
  const email = String(item.email || item.displayEmail || '').trim() || null;
  const phone = String(item.phone || item.displayPhone || '').trim() || null;
  const contactLine = [phone, email].filter(Boolean).join(' | ');
  const searchName = normalizeSearchValue(name);
  const searchEmail = normalizeSearchValue(email);
  const searchPhone = normalizeSearchValue(phone);

  return {
    customerId,
    name,
    email,
    phone,
    contactLine,
    searchName,
    searchEmail,
    searchPhone,
    searchText: [searchName, searchEmail, searchPhone].filter(Boolean).join(' '),
    searchDigits: digitsOnly(phone),
    emailDigits: digitsOnly(email),
  };
};

export const getCustomerContactLine = (customer) => {
  if (customer?.contactLine != null) {
    return customer.contactLine;
  }

  return [customer?.phone, customer?.email]
    .map((part) => String(part || '').trim())
    .filter(Boolean)
    .join(' | ');
};

export const customerMatchesQuery = (customer, query) => {
  const needle = normalizeSearchValue(query).trim();
  if (!needle) {
    return true;
  }

  const searchName = customer?.searchName ?? normalizeSearchValue(customer?.name);
  const searchEmail = customer?.searchEmail ?? normalizeSearchValue(customer?.email);
  const searchPhone = customer?.searchPhone ?? normalizeSearchValue(customer?.phone);
  const searchText = customer?.searchText ?? [searchName, searchEmail, searchPhone].filter(Boolean).join(' ');

  if (searchName.includes(needle)
    || searchEmail.includes(needle)
    || searchPhone.includes(needle)
    || searchText.includes(needle)) {
    return true;
  }

  const hasLetters = /[a-z]/i.test(needle);
  if (hasLetters) {
    return false;
  }

  const queryDigits = digitsOnly(query);
  if (!queryDigits) {
    return false;
  }

  const phoneDigits = customer?.searchDigits ?? digitsOnly(customer?.phone);
  const emailDigits = customer?.emailDigits ?? digitsOnly(customer?.email);
  return phoneDigits.includes(queryDigits) || emailDigits.includes(queryDigits);
};

export const filterCustomerDropdownOptions = (options, query, limit = 75) => {
  const needle = String(query || '').trim();
  if (!needle) {
    const all = options || [];
    return all.length > limit ? all.slice(0, limit) : all;
  }

  const filtered = (options || []).filter((option) => customerMatchesQuery(option, needle));
  return filtered.length > limit ? filtered.slice(0, limit) : filtered;
};
